import { IOption } from 'components/Select/type';
import { IQuestion } from 'types/Question.types';
import { IColor } from './ColorModal';

export const extractColorsFromQuestion = (question: IQuestion): IColor[] => {
  const outputKeys = Object.keys(question.outputs);

  return question.options.map((option: any[]) => {
    const color: any = {};
    outputKeys.forEach((key, index) => {
      // Set each property of the IColor object from the corresponding index in the options array
      // Uses the key from outputs as the field name
      color[key] = option[index] ? option[index].toString() : '';
    });
    return color;
  });
};

export const extractColorCollectionOptions = (colors: IColor[]): IOption[] => {
  // Create a set to ensure all collections are unique
  const collectionsSet = new Set<string>();

  // Iterate over each color and add its collection to the set if it's not an empty string
  colors.forEach((color) => {
    if (color.collection) {
      // Check if collection is not empty
      collectionsSet.add(color.collection);
    }
  });

  // Convert the set back to an array and return
  const colorCollections: IOption[] = Array.from(collectionsSet).map(
    (collectionString: string) => {
      return { label: collectionString, value: collectionString };
    }
  );
  colorCollections.unshift({ label: 'All collections', value: '' });
  return colorCollections;
};

export const filterColorsByCollectionAndSearchTerm = (
  colors: IColor[],
  selectedCollection: string,
  colorSearchBy: string
) => {
  return colors.filter((color: IColor) => {
    let matches = false;
    const colorKeys = Object.keys(color);
    if (selectedCollection && color.collection !== selectedCollection) {
      return false;
    }
    if (!colorSearchBy) {
      return true;
    }
    for (const colorKey of colorKeys) {
      if (['popular', 'image'].includes(colorKey)) {
        continue;
      }
      if (color[colorKey].toLowerCase().includes(colorSearchBy.toLowerCase())) {
        matches = true;
      }
    }

    return matches;
  });
};

// Hex values rather than theme variables, since the label contrast is computed from them
const NEUTRAL_COLOR_BACKGROUND = '#f6fcf7';
const NEUTRAL_COLOR_BACKGROUND_DARK = '#222737'; // --color-background

export const getColorBackground = (color: IColor, darkMode: boolean) => {
  if (!color.image && color.hex_code) return color.hex_code;
  return darkMode ? NEUTRAL_COLOR_BACKGROUND_DARK : NEUTRAL_COLOR_BACKGROUND;
};

export const getIsColorSelected = (
  color: IColor,
  chosenColor: IColor | undefined
) => {
  if (!chosenColor) return false;

  // Compare all populated fields to ensure unique match
  // This handles different data structures where field names vary
  const keysToCompare = Object.keys(color).filter(
    (key) => color[key as keyof IColor] && chosenColor[key as keyof IColor]
  );

  return keysToCompare.every(
    (key) => color[key as keyof IColor] === chosenColor[key as keyof IColor]
  );
};
